import { useEffect, useState } from "react";

const KEY = "msb_logo_design";
const DEFAULT = "lighthouse";

/** Reactively reads the active logo design from localStorage. */
export function useLogoDesign() {
  const [design, setDesign] = useState(() => {
    try { return localStorage.getItem(KEY) || DEFAULT; }
    catch { return DEFAULT; }
  });

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === KEY && e.newValue) setDesign(e.newValue);
    };
    const onCustom = (e) => {
      if (e.detail) setDesign(e.detail);
    };
    window.addEventListener("storage", onStorage);
    window.addEventListener("msb-logo-design", onCustom);
    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("msb-logo-design", onCustom);
    };
  }, []);

  return design;
}
